import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { FormatDatasetV2 } from './dataset.v2';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.icebergDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.ModelName_IcebergDataset),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.ModelName_IcebergDataset)
    ]
})
export class IcebergDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
